

























































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/components/public/Search.vue'
import router from '@/router'
import buyApi from '@/api/buyApi';
import moment from 'moment';
import index from '@/stores';

@Component({
  components: {
    Search,
  }
})
export default class ChoiceGoods extends Vue {
  private step: string = '2'
  private form: any
  private searchStr: string = ''
  private switchType: boolean = false
  private skus: number = 3
  private list: any[] = []
  private enableForm: boolean = false
  private choiceIds: any[] = []
  private goodsList: any[] = []

  private fields: any[] = []

  private choiceItems: any[] = []

  private validate: any = {
    remarkRules: [{ type: 'array', required: true, message: '请填写备注！' }],
    priseRules: [{ type: 'array', required: true, message: '请填写价格！' }],
    dateRules: [{ type: 'array', required: true, message: '请选择日期！' }],
    payType: [{ required: true, message: '请选择支付类型' }],
  }

  public beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  public mounted(): void {
    this.step = this.$route.query.step as string
    this.getGoodsList()
  }

  // 进入页面获取数据
  protected getGoodsList() {
    buyApi.choiceGoods({
      id: this.$route.query.id,
      commodityName: this.searchStr || ''
    }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        this.goodsList = res.data.commodities
        this.fields = res.data.limitRespVOs
        // //  获取限制条件
        // res.data.limitRespVOs.map((item?:any)=>{
        //   this.validate[item.type] == [{ type: 'array', required: item.required, message: '请填写信息' }];
        // })

        this.searchStr = ''
        this.skus = res.data.skus
        this.enableForm = res.data.enableConnectCommodity
        if (this.choiceItems.length > 0) {
          this.choiceItems.forEach((v: any) => {
            this.choiceIds.push(v.commodityCode)
          });
        }
      }
    })
  }

  // 点击商品搜索
  protected search(a: string) {
    this.searchStr = a
    this.getGoodsList()
  }

  // 点击删除商品
  protected delGoods(item: any) {
    let itemIndex = this.choiceItems.indexOf(item)
    this.choiceItems.splice(itemIndex, 1)
    this.goodsList.forEach((v: any) => {
      if (v.commodityCode === item.commodityCode) {
        v.enabledSelected = true
      }
    })
    if (this.choiceIds.length > 0) {
      let index = this.choiceIds.indexOf(item.commodityCode)
      this.choiceIds.splice(index, 1)
    }
  }

  // 选中商品
  protected choice(item: any) {
    if (item.enabledSelected) {
      let obj = {
        commodityCode: item.commodityCode,
        commodityFieldRespVOs: [] as any[],
        commodityName: item.commodityName
      }
      if (this.fields && this.fields.length > 0) {
        this.fields.forEach(field => {
          obj.commodityFieldRespVOs.push({
            id: field.id,
            value: '',
            define: field,
          })
        })
      }

      if (this.skus > this.choiceItems.length) {
        if (this.choiceItems.length === 0) {
          this.choiceItems.push(obj)
        } else {
          if (!this.choiceItems.find(n => {
            return n.commodityCode == obj.commodityCode})) {
            this.choiceItems.push(obj)
          }
        }
        item.enabledSelected = false

      } else {
        this.$message.warning('只可选中' + this.skus + '商品');
      }
    }
  }

  // 下一个页面
  protected next(e: any) {
    e.preventDefault();
    let step = '2'
    if (!this.enableForm) {
      this.upload()
      router.push({ name: 'buy', query: { step, id: this.$route.query.id, stepStatus: this.$route.query.stepStatus, tradeSize: this.$route.query.tradeSize } })
      return
    }
    if (this.choiceItems.length === 0) {
      this.$message.warning('请选择要关联的商品');
      return false
    }
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.upload()
      } else {
        this.$message.warning('请完成商品表单内容填写');
      }
    });
  }
// 处理时间组件的
  protected rangePickerChange(field: any, dates: any[], dateStrings: string[]) {
    if (dates && dates.length == 2) {
      field.value = dates[0].valueOf() + ';' + dates[1].valueOf()
    }
  }

  // 通过验证后调用
  private upload() {
    const params = {
      commodities: this.choiceItems,
      resourceId: this.$route.query.id,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }
    buyApi.submitGoods(params).then((res) => {
      if (res.code === 200) {
        const step = '2'
        router.push({ name: 'buy', query: { step, id: params.resourceId, stepStatus: this.$route.query.stepStatus, tradeSize: this.$route.query.tradeSize } })
      } else {
        this.$message.warning(res.msg);
      }
    })
  }
}
